export default "__VITE_ASSET__aqAqLVFH__"